module.exports = __webpack_public_path__ + "static/media/Instgram_Logo.a1e9160d.svg";